import agent from '../agent'
import {
    FETCH_AUDIENCES_LOADED,
    FETCH_AUDIENCES_STARTED
} from "../constants/actionTypes"

export const fetchAudiencesFinished = (payload) => ({
    type: FETCH_AUDIENCES_LOADED,
    payload
})

export const fetchAudiencesStart = () => ({
    type: FETCH_AUDIENCES_STARTED
})

export const fetchAudiences = (dispatch) => () => {
    dispatch(fetchAudiencesStart());
    agent.Audiences.getAudiences().then(res => {
        dispatch(fetchAudiencesFinished(res));
    }, err => {
        dispatch(fetchAudiencesFinished(err));
    })
}
